<template>
  <div class="discount-connection-selection">
    <img class="logo-image" :src="require(`@/assets/bank-logos/${source.logoFile}`)">
    <div class="choose-connection-title">איזה סוג חשבון בנק תרצו לחבר לשירות?</div>
    <div class="buttons-container">
      <riseup-button :title="'חשבון עם בעלים יחיד'"
                     :subtitle="'החשבון רשום על שם אדם אחד בלבד'"
                     :action="() => setSourceName('דיסקונט ישיר')" />
      <div class="separator"><div class="line"></div><div class="or">או</div><div class="line"></div></div>
      <riseup-button :title="'משותף עם מס׳ בעלים'"
                     :subtitle="'לדוג׳: רשום על שם שני בני זוג'"
                     :action="() => setSourceName('דיסקונט')" />
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapGetters } from 'vuex';

export default {
  name: 'DiscountConnectionSelection',
  props: {
    setSourceName: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters('sourceFields', ['getSourceBySourceName']),
    source() {
      return this.getSourceBySourceName('דיסקונט');
    },
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../scss/mixins';

.discount-connection-selection {
  width: 100%;
  padding-top: 30px;
  @include responsive-padding;

  .logo-image {
    height: 40px;
    margin-bottom: 20px;
  }

  .choose-connection-title {
    font-size: 18px;
    font-family: SimplerPro;
    margin-bottom: 30px;
  }

  .buttons-container {
    .riseup-button {
      width: 100%;
      margin-bottom: 30px;
    }

    .separator {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      color: $riseup_gray_2;
      margin-bottom: 30px;

      .line {
        height: 1px;
        width: 100%;
        background-color: $riseup_gray_1;
      }

      .or {
        margin: 0 15px;
        color: $riseup_black;
      }
    }
  }
}
</style>
